import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { AuthorFormGroupModel } from 'src/app/models/form-group.model';
import { ApiService } from 'src/app/services/api.service';
import { Location } from '@angular/common';

@Component({
  selector: 'fury-author-add-edit',
  templateUrl: './author-add-edit.component.html',
  styleUrls: ['./author-add-edit.component.scss'],
   animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AuthorAddEditComponent implements OnInit {

  authorForm!: FormGroup;
  imagestoupload: any;
  authorId!: string;

  constructor(
    public apiService: ApiService,
    private path: ActivatedRoute,
    private router: Router,
    public location: Location,
  ) {
    this.formInIt();
  }

  ngOnInit(): void {
    this.path.params.subscribe((res: any) => {
      if (res?.id) {
        this.authorId = res.id;
        this.getAutherAndPatchData();
      }
    });
  }

  getAutherAndPatchData() {
    this.apiService.get(`admin/author/get-author/${this.authorId}`).subscribe((res: any) => {
      if (res.body) {
        this.authorForm.patchValue({
          fullName: res.body.author.fullName,
          designation: res.body.author.designation,
          linkedinUrl: res.body.author.linkedinUrl,
          description: res.body.author.description,
        });
        this.imagestoupload = res.body.author.profilePicture;
      }
    }, err => {
      this.apiService.alert(err.error.message, ErrorType.Error);
      this.location.back();
    })
  }

  formInIt() {
    this.authorForm = new FormGroup<AuthorFormGroupModel>({
      profilePicture: new FormControl(''),
      fullName: new FormControl('', [Validators.required]),
      designation: new FormControl('', [Validators.required]),
      linkedinUrl: new FormControl('', [Validators.required, Validators.pattern(/^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)\/([\w]{1,})?/)]),
      description: new FormControl('', [Validators.required]),
    });
  }
  onImageUpload(event: any) {
    if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg') {
      let file;
      file = event.target.files[0];
      this.authorForm.patchValue({ profilePicture: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagestoupload = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.apiService.alert(ErrorText.ImageRestriction, 'error');
    }
  }

  submit() {
    if (this.authorForm.valid) {
      const url = this.authorId ? `admin/author/update-author/${this.authorId}` : 'admin/author/create-author';
      if (this.imagestoupload) {
        const data = new FormData();

        Object.keys(this.authorForm.value).forEach(fieldName => {
          if (this.authorForm.controls[fieldName]) {
            data.append(fieldName, this.authorForm.value[fieldName]);
          }
        })

        this.apiService.postMultiData(url, data).subscribe(res => {
          if (res.body) {
            this.apiService.alert(res.body.message, ErrorType.Success);
            this.location.back();
          } else {
            this.apiService.alert(res.body.message, ErrorType.Warning)
          }
        }, err => {
          if (err) {
            Object.keys(err.errors).map((error) => {
              this.apiService.alert(err.errors[error], ErrorType.Error);
            })
          }
        })
      } else {
        this.apiService.alert(ErrorText.PleaseUploadTheImage, ErrorType.Error);
      }

    } else {
      this.authorForm.markAllAsTouched()
    }
  }

  back() {
    this.location.back();
  }

}
